import { v4 as uuid } from 'uuid';

export let browserSessionUuid: string;

export function initBrowserSession() {
    browserSessionUuid = uuid();
}
